import { ScreenBaseWrapper, type ScreenBaseWrapperWidth } from 'noddi-ui-web';
import { PropsWithChildren } from 'react';

export type BookingWrapperWidth = ScreenBaseWrapperWidth;

interface Props {
  width?: BookingWrapperWidth;
  wrapperClassName?: string;
}

export const BookingWrapper = ({ children, width = 'lg', wrapperClassName }: PropsWithChildren<Props>) => (
  <ScreenBaseWrapper width={width} className={wrapperClassName}>
    {children}
  </ScreenBaseWrapper>
);
